import { API_URL } from '../env';

class Client {
  protected async request(path, options) {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    const url = `${API_URL}/${path}`;

    try {
      const response = await fetch(url, {
        ...options,
        headers: headers,
        body: options.body,
        credentials: 'include'
      });

      if (response.status < 300) {
        return response.json();
      }

      return null;
    } catch (error) {
      console.error('Error during request', error);
      return null;
    }
  }
}

export class AuthClient extends Client {
  async signUp(payload) {
    return this.request('signup', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async login(payload) {
    return this.request('login', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async getSession() {
    return this.request('sessions', {
      method: 'GET'
    });
  }

  async logout() {
    return this.request('logout', {
      method: 'DELETE'
    });
  }
}

type RecordValue = string | number | boolean | null | undefined;

export class APIClient<T> extends Client {
  private resource: string;

  constructor(resource: string) {
    super();
    this.resource = resource;
  }

  async create(payload: Record<string, RecordValue>) {
    return this.request(this.resource, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  async index() {
    return this.request(this.resource, {
      method: 'GET'
    });
  }

  async show(id: string) {
    return this.request(`${this.resource}/${id}`, {
      method: 'GET'
    });
  }

  async update(id: string, json: T) {
    return this.request(`${this.resource}/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(json)
    });
  }

  async destroy(id: string) {
    return this.request(`${this.resource}/${id}`, {
      method: 'DELETE'
    });
  }
}
